import React, { useState, useCallback, useEffect, useMemo } from 'react'
import HeaderTitle from '_/components/header-title'
import { Grid, InputAdornment } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import { Datagrid, Button } from '@refera/ui-web'
import { navigate } from '@reach/router'
import { useDispatch, useSelector } from 'react-redux'

import { getLaborTypesSelector } from '_/modules/labor-type/selectors'

import { useToast } from '_/hooks/use-toast'
import useHandleInput from '_hooks/use-handle-input'
import SearchBar from '_components/search-bar'
import { getLaborTypes } from '_/modules/labor-type/actions'

import { TYPE_COLUMNS } from './utils/constants'
import useStyles, { datagridStyle } from './styles'
import { ROUTES } from '_/utils/constants'

export default function LaborTypeList() {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { showToast } = useToast()

  const types = useSelector(getLaborTypesSelector)
  const [loading, setLoading] = useState(false)
  const [input, handleInput] = useHandleInput()
  const [searchValue, setSearchValue] = useState('')
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [orderBy, setOrderBy] = useState('')

  const handleSearch = useCallback(() => {
    setSearchValue(input)
    setPage(0)
  }, [input])

  const handleKeyDown = useCallback(
    e => {
      if (e.key === 'Enter') {
        handleSearch()
      }
    },
    [handleSearch]
  )

  const inputProps = useMemo(
    () => ({
      endAdornment: (
        <InputAdornment position="end">
          <SearchIcon onClick={handleSearch} style={{ cursor: 'pointer' }} />
        </InputAdornment>
      ),
    }),
    [handleSearch]
  )

  const handleOrderBy = orderObj => {
    const order = orderObj[0]
    if (!order) {
      setOrderBy('')
      return
    }
    const { field, sort } = order
    setOrderBy(`${sort === 'desc' ? '-' : ''}${field}`)
  }

  const handleGoToType = useCallback(params => {
    if (!params?.row?.id) {
      return
    }

    navigate(`${ROUTES.SERVICES_TYPE_LIST}/${params.row.id}`)
  }, [])

  const handleCreate = useCallback(() => {
    navigate(`${ROUTES.SERVICES_TYPE_LIST}/novo`)
  }, [])

  useEffect(() => {
    setLoading(true)

    dispatch(getLaborTypes({ page: page + 1, pageSize, orderBy, name: searchValue }))
      .catch(() => {
        showToast({ type: 'error', message: 'Ocorreu um erro ao buscar tipos de MO' })
      })
      .finally(() => setLoading(false))
  }, [dispatch, page, pageSize, orderBy, showToast, searchValue])

  return (
    <Grid className={styles.container}>
      <HeaderTitle title="Tipos de MO" backButtonAction={() => navigate(ROUTES.SERVICE)}>
        <Grid className={styles.headerButtons}>
          <SearchBar
            className={styles.searchBar}
            value={input}
            onChange={handleInput}
            placeholder="Pesquisar tipo de MO"
            InputProps={inputProps}
            onKeyDown={handleKeyDown}
          />
          <Button variant="primary" disabled={loading} onClick={handleCreate}>
            Novo
          </Button>
        </Grid>
      </HeaderTitle>

      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            rows={types?.results ?? []}
            rowCount={types?.count ?? 0}
            loading={loading}
            getRowId={row => row?.id}
            columns={TYPE_COLUMNS}
            paginationMode="server"
            onPageChange={setPage}
            page={page}
            onPageSizeChange={setPageSize}
            pageSize={pageSize}
            onSortModelChange={handleOrderBy}
            sx={datagridStyle}
            onRowClick={handleGoToType}
            disableSelectionOnClick
          />
        </Grid>
      </Grid>
    </Grid>
  )
}
